import { DateField } from "@/components/admin/date-field";
import { NumberField } from "@/components/admin/number-field";
import { RecordField } from "@/components/admin/record-field";
import { ReferenceField } from "@/components/admin/reference-field";
import { Show } from "@/components/admin/show";
import { Card, CardContent } from "@/components/ui/card";

export const TransferShow = () => (
  <Show>
    <Card>
      <CardContent className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <RecordField source="from_account_id">
          <ReferenceField
            source="from_account_id"
            reference="accounts"
            link="show"
          />
        </RecordField>
        <RecordField source="to_account_id">
          <ReferenceField
            source="to_account_id"
            reference="accounts"
            link="show"
          />
        </RecordField>
        <RecordField source="amount" field={NumberField} />
        <RecordField source="occurred_at" field={DateField} />
        <RecordField source="description" className="md:col-span-2" />
      </CardContent>
    </Card>
  </Show>
);
